import {observer} from 'mobx-react'
import {Link} from 'react-router-dom'
import HELP from '../stores/Help'
import UI from '../stores/UI'
import Logo from './Logo'


const startScale = UI.isMobileSmall ? 1 : 2

class Header extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      y: (window.innerHeight * 0.5) - 40,
      scale: startScale,
      done: false
    }
  }

  componentWillMount() {
    this.handleScroll()
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('resize', this.handleScroll)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll, false)
    window.removeEventListener('resize', this.handleScroll, false)
  }

  handleScroll = e => {

    const startPosition = (window.innerHeight * 0.5) - 40
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop
    const proportion = scrollTop / window.innerHeight * 1.2
    const shouldUpdate = proportion <= 1

    if (scrollTop / window.innerHeight * 100 > 25) {
      UI.togglePrompt(false)
    } else {
      UI.togglePrompt(true)
    }

    if (shouldUpdate) {
      UI.listenToTransform(true)
    } else {
      UI.listenToTransform(false)
    }

    this.setState({
      y: shouldUpdate ? startPosition - (startPosition * proportion) : 0,
      scale: shouldUpdate && !UI.isMobileSmall ? startScale - (proportion) : 1,
      done: shouldUpdate ? false : true
    })
  }

  render() {

    const css = {
      transform: !UI.isProjectOpen && UI.showIntroPadding ? `translateY(${this.state.y}px) scale(${this.state.scale})` : `translateY(0px) scale(1)`,
      transition: `opacity 0.5s`,
      opacity: UI.isProjectOpen ? 0 : 1
    }

    const linkCss = {
      opacity: this.state.done || UI.isProjectOpen || !UI.showIntroPadding ? 1 : 0,
      transition: `opacity 0.3s`
    }

    return (
      <header className="default-bg-color">
        <nav style={css}>
          <Link to="/projects" className="index" style={linkCss}>Index</Link>
          <Link to="/" className="name"><Logo /></Link>
          <Link to="/info" className="info" style={linkCss}>Info</Link>
          <div className="mobile-links" style={linkCss}>
            <Link to="/projects">Index</Link>
            <a>—</a>
            <Link to="/info">Info</Link>
          </div>
        </nav>
      </header>
    )
  }
}

export default observer(Header)



// WEBPACK FOOTER //
// ./app/javascript/packs/components/Header.js